var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0.0820312 0.583313L5.91537 0.583313L5.91537 1.41665L0.0820312 1.41665L0.0820312 0.583313Z",
    transform: "translate(2, 4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxLine);
export default __webpack_public_path__ + "static/media/checkbox-line.49afb5a0c5dae297b748961769d8eefc.svg";
export { ForwardRef as ReactComponent };